import { useMutation } from '@tanstack/react-query'
import { config } from '../../config'
import { sessionStore } from '../../sharedStores/sessionStore'
import { useToast } from '../../utils/ToastContext'
import { queryClient, trpcClient } from '../../utils/trpc'
import { clearStorage, getOktaLogoutUrl } from './authHelpers'

export const useLogout = () => {
	const toast = useToast()

	const logout = useMutation({
		mutationFn: async () => {
			// Wait for API to complete and clear server-side session cookie first
			return trpcClient.admin.auth.logout.mutate()
		},
		onSuccess: () => {
			const oktaLogoutUrl = getOktaLogoutUrl()

			// Clear frontend state
			clearStorage()
			sessionStore.getState().logout()
			queryClient.clear()
			toast.showToast('Successfully logged out')

			// Redirect to Okta logout to clear SSO session, then back to our login page
			// In local env, just navigate to login page directly
			if (config.env === 'local' || config.env === 'dev' || config.env === 'demo') {
				window.location.href = '/auth/login'
			} else {
				window.location.href = oktaLogoutUrl
			}
		},
		onError: () => {
			const oktaLogoutUrl = getOktaLogoutUrl()

			// Even on error, clear frontend state and redirect to Okta logout
			clearStorage()
			sessionStore.getState().logout()
			queryClient.clear()

			if (config.env === 'local' || config.env === 'dev' || config.env === 'demo') {
				window.location.href = '/auth/login'
			} else {
				window.location.href = oktaLogoutUrl
			}
		},
	})

	return { logout }
}
